import {ON_RESOURCES_LIST,ON_ACTIONS_LIST} from '../constants/ActionTypes';

const INIT_STATE = {
    resourcesList: [],
    actionsList:[]
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_RESOURCES_LIST: {
            return {...state, resourcesList: action.payload};
        }
        case ON_ACTIONS_LIST: {
            return {...state, actionsList: action.payload};
        }
        default:
            return state;
    }
}